import React, { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'react-addons-update';

import { Icon, Step } from 'semantic-ui-react';

const propTypes = {
};

const defaultProps = {
};

class StepMenu extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  render() {
    let step01 = '', step02 = '', step03 = '', step04 = '';

    const { data } = this.props;

    switch ( data.nowStep ) {
      case "step1" :
        step01 = 'active';
        break;
      case "step2" :
        step01 = 'active completed';
        step02 = 'active';
        break;
      case "step3" :
        step01 = 'active completed';
        step02 = 'active completed';
        step03 = 'active';
        break;
      case "step4" :
        step01 = 'active completed';
        step02 = 'active completed';
        step03 = 'active completed';
        step04 = 'active completed';
        break;
      default:
        break;
    }

    let stepTitle = {
      step1 : "지급할 사용자 선택"
      , step2 : "지급할 정책 선택"
      , step3 : "정책별 유효기간/금액 설정"
      , step4 : "지급 완료"
    }

    if( data.tabType === "deduct" ) {

        stepTitle = {
          step1 : "차감할 사용자 선택"
          , step2 : "차감할 정책 선택"
          , step3 : "정책별 금액 설정"
          , step4 : "차감 완료"
        }

    }



    return(

      <div>
        <Step.Group>
          <Step className={step01}>
            <Step.Content title={ "Step1. " + stepTitle.step1 }/>
            <Icon name='warning circle' />
          </Step>

          <Step className={step02}>
            <Step.Content title={ "Step2. " + stepTitle.step2 }/>
            <Icon name='warning circle' />
          </Step>

          <Step className={step03}>
            <Step.Content title={ "Step3. " + stepTitle.step3 }/>
            <Icon name='warning circle' />
          </Step>

          <Step className={step04}>
            <Step.Content title={ "Step4. " + stepTitle.step4 }/>
            <Icon name='warning circle' />
          </Step>
        </Step.Group>
      </div>

    );
  }
}

StepMenu.propTypes = propTypes;
StepMenu.defaultProps = defaultProps;

export default StepMenu;
